import { Injectable } from "@angular/core";
import { Http } from '@angular/http';

@Injectable()
export class DashboardService {
  constructor(public http: Http) {}

  getData(): Promise<any> {
    return this.http.get('./assets/dashboardData/dashboardListing.json')
     .toPromise()
     .then(response => response.json())
     .catch(this.handleError);
  }

  getDataInvestor(): Promise<any> {
    return this.http.get('./assets/dashboardData/dashboardListingInvestor.json')
     .toPromise()
     .then(response => response.json())
     .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}


// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.service.ts